/* eslint-disable prettier/prettier */
import CryptoJS from 'crypto-js'

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY

export const encryptPassword = (password) => {
    if (!SECRET_KEY) {
        throw new Error('Encryption key is missing. Check your .env file.')
    }

    const key = CryptoJS.enc.Utf8.parse(SECRET_KEY)
    const encrypted = CryptoJS.AES.encrypt(password, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    })

    return encrypted.toString()
}
